import React from 'react';
import { capitalize } from 'lodash';
import { getMessage } from 'util/locale';
import PopoverTrigger from 'triggers/PopoverTrigger';
import OptionsMenuPopoverContainer from 'manage/OptionsMenuPopoverContainer';

const baseString = 'vra-options-menu';

interface OptionsMenuProps {
  onClick: () => void;
  onHideCallback?: () => void;
  scriptOptionsIsOpen: boolean;
}

const OptionsMenu = ({
  onClick,
  onHideCallback,
  scriptOptionsIsOpen
}: OptionsMenuProps) => {

  const trigger = (
    <button
      className={`${baseString}__trigger`}
      data-test-id="rx-options"
      onClick={onClick}
    >
      {capitalize(getMessage('button-text__more'))}
    </button>
  );

  const hideCallback = onHideCallback || onClick;

  return (
    <PopoverTrigger
      popoverName="options-menu"
      popoverPlacement="right"
      trigger={trigger}
      className={baseString}
      onHideCallback={hideCallback}
      popoverIsOpen={scriptOptionsIsOpen}
      popoverContent={<OptionsMenuPopoverContainer />}
    />
  );
};

export default OptionsMenu;
